import { Divider } from "@chakra-ui/react";
import { Error, Loader } from "components";
import { ApiRequestStatusEnum } from "enums/api-request-status.enum";
import { observer } from "mobx-react";
import React, { FC, useEffect, useState } from "react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { AutomatedReferralsOfficeConfigurator } from "./AutomatedReferralsIntegrationOfficesConfigurator/AutomatedReferralsOfficeConfigurator";
import { AutomatedReferralsSendOutOfAreaLeadsConfigurator } from "./AutomatedReferralsSendOutOfAreaLeadsConfigurator";

interface IProps {
  accountStore: UserAccountStore;
}

export const AutomatedReferralsIntegrationConfigurator: FC<IProps> = observer(
  ({ accountStore }) => {
    const [loadingStatus, setLoadingStatus] = useState(
      ApiRequestStatusEnum.NONE
    );

    const accountOfficesStore = accountStore.accountOfficesStore;
    const accountIntegrationsStore = accountStore.accountIntegrationsStore;
    const accountIntegrationAutomatedReferralsStore =
      accountIntegrationsStore.accountIntegrationAutomatedReferralsStore;

    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoadingStatus(ApiRequestStatusEnum.PENDING);
          await Promise.all([
            accountOfficesStore.fetchAccountOffices(),
            accountIntegrationAutomatedReferralsStore.fetchAccountAutomatedReferralsOfficeRelations(),
          ]);
          setLoadingStatus(ApiRequestStatusEnum.SUCCESS);
        } catch (e) {
          setLoadingStatus(ApiRequestStatusEnum.ERROR);
        }
      };

      fetchData();
    }, [accountOfficesStore, accountIntegrationAutomatedReferralsStore]);

    return (
      <>
        {loadingStatus === ApiRequestStatusEnum.PENDING && <Loader />}
        {loadingStatus === ApiRequestStatusEnum.ERROR && <Error />}
        {loadingStatus === ApiRequestStatusEnum.SUCCESS && (
          <>
            <AutomatedReferralsSendOutOfAreaLeadsConfigurator
              accountIntegrationsStore={accountIntegrationsStore}
            />
            <Divider mb={4} />
            <AutomatedReferralsOfficeConfigurator
              automatedReferralsStore={
                accountIntegrationAutomatedReferralsStore
              }
            />
          </>
        )}
      </>
    );
  }
);
